import constants from "./constants";
import { createProofClient, ProofError } from "./powClient";

let status = { state: "idle" };
const listeners = new Set();
// One lazily loaded invisible widget serves the whole app; API renewal is serialized
// by createProofClient, so two callers never reconfigure its workers simultaneously.
let widgetPromise = null;
export const getProofStatus = () => status;
export function subscribeProofStatus(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
function publish(next) {
    status = next;
    listeners.forEach(listener => listener());
}
/** Create ALTCHA only when work is needed, then wait for its public API to load. */
function getWidget() {
    if (!widgetPromise) {
        // ALTCHA is an ESM side-effect bundle. CRA otherwise injects CommonJS helpers.
        // eslint-disable-next-line import/no-webpack-loader-syntax
        widgetPromise = import('!!babel-loader?{"babelrc":false,"configFile":false,"sourceType":"module","presets":[["babel-preset-react-app/dependencies",{"helpers":true}]]}!altcha').then(() => new Promise((resolve, reject) => {
            const widget = document.createElement("altcha-widget");
            widget.setAttribute("auto", "off");
            widget.setAttribute("display", "invisible");
            widget.setAttribute("aria-hidden", "true");
            widget.setAttribute("configuration", JSON.stringify({
                humanInteractionSignature: false, workers: 2, timeout: 90000,
            }));
            const timeout = setTimeout(() => {
                widget.remove();
                reject(new ProofError("pow_unavailable"));
            }, 15000);
            widget.addEventListener("load", () => {
                clearTimeout(timeout);
                resolve(widget);
            }, { once: true });
            // Module ownership survives React StrictMode's setup/cleanup/remount cycle.
            document.body.appendChild(widget);
        })).catch(error => { widgetPromise = null; throw error; });
    }
    return widgetPromise;
}
/**
 * Let ALTCHA's workers solve the server-issued challenge without blocking React.
 * The returned payload is only a proposed solution: the backend must verify its
 * signature, bindings, expiry and work before granting requests.
 */
async function solveProof(challenge) {
    const widget = await getWidget();
    await widget.configure({ challenge, humanInteractionSignature: false });
    const result = await widget.verify();
    if (!result?.payload) throw new ProofError("pow_failed");
    return result.payload;
}
// Module scope coordinates renewal. Storage contains only untrusted hints; the
// HttpOnly identity cookie and backend state remain the authority.
export const apiFetch = createProofClient({
    baseUrl: constants.BACKEND,
    fetchImpl: (...args) => fetch(...args),
    solveProof,
    onStatus: publish,
    // Access can throw when browser storage is disabled; the client catches it.
    storage: { getItem: key => localStorage.getItem(key),
        setItem: (key, value) => localStorage.setItem(key, value),
        removeItem: key => localStorage.removeItem(key) },
    storageKey: "padelstats-pow-allowance-v1",
});

// Warm up access when the website opens; components share this same promise.
export const prepareProof = () => apiFetch.prepare();
